// @flow
import * as React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { HashLink as RouterLink } from 'react-router-hash-link';
import UpdateRequiredContext from 'containers/UpdateRequiredContext';

const BaseLink = ({
  component,
  to,
  ...props
}: {
  component: React.ComponentType<any>,
  to: string | { pathname: string, state?: Object }
}) => {
  const Component = component;
  const isStateless =
    typeof to === 'string' || (typeof to === 'object' && !to.state);
  return (
    <UpdateRequiredContext.Consumer>
      {updateRequired =>
        updateRequired && isStateless ? (
          <a href={to} {...props} />
        ) : (
          <Component to={to} {...props} />
        )
      }
    </UpdateRequiredContext.Consumer>
  );
};

export const NavLink = (props: mixed) => (
  <BaseLink component={RouterNavLink} {...props} />
);

export const Link = (props: mixed) => (
  <BaseLink component={RouterLink} {...props} />
);
